export enum E_PROMOTION_CODE_TYPE {
  PERCENTAGE = "PERCENTAGE",
  FIXED_AMOUNT = "FIXED_AMOUNT",
}

export const PromotionCodeLabels: Record<E_PROMOTION_CODE_TYPE, string> = {
  [E_PROMOTION_CODE_TYPE.PERCENTAGE]: "เปอร์เซนต์",
  [E_PROMOTION_CODE_TYPE.FIXED_AMOUNT]: "จำนวน",
};
